"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarEventServiceOptionalSchema () {
        return CalendarEventServiceOptionalSchema;
    },
    get CalendarEventServiceSchema () {
        return CalendarEventServiceSchema;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const CalendarEventServiceSchema = _zod.z.object({
    /**
	 * The external calendar event ID from the provider (Google, Outlook, etc.)
	 */ eventId: _zod.z.string(),
    /**
	 * The calendar provider that hosts this event
	 */ provider: _zod.z.enum([
        "google",
        "outlook"
    ]),
    /**
	 * The calendar ID within the provider where this event is stored
	 */ calendarId: _zod.z.string(),
    /**
	 * When this calendar event record was first created
	 */ created: _utilsisomorphic.transformDate,
    /**
	 * When this calendar event record was last updated
	 */ updated: _utilsisomorphic.transformDate
});
const CalendarEventServiceOptionalSchema = CalendarEventServiceSchema.optional();
